<template>
    <router-link :to="'/user/'+ user.id" class="party-user" >
        <div class="party-user__avatar" :style="{ backgroundImage: 'url(' + user.avatar + ')' }"></div>
        <p class="party-user__name">{{ user.firstname + ' ' + user.lastname }}</p>
    </router-link>
</template>
<script>
export default {
    name: 'UserMini',
    props: {
        user: {
            type: Object,
            required: true
        },
        deletable: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>
<style lang="stylus">
.user-mini
    display flex
    flex-direction column
    align-items center
    margin 10px 10px
    position relative

    &__avatar
        width 50px
        height 50px
        border-radius 50%
        margin-bottom 8px
        background-color #333
        background-size cover
        background-position center
    
    &__name
        font-size 11px
        font-weight 500
        line-height 13px
        width min-content
        text-align center
        color #73a2b5
</style>